module.exports = __webpack_public_path__ + "img/meditation.4a3b9c5f.svg";